import React from "react";
import { Card, CardBody, CardTitle, CardSubtitle, CardText } from "reactstrap";
import styled from "styled-components";
import Slider from "react-slick";
import { Typography } from "@mui/material";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import "./IntervenantsHome.css";
import Rating from "react-rating-stars-component";
import { useNavigate, NavLink } from "react-router-dom";
import GlobalContext from "../../../../Context/GlobalContext";
import Skeleton from "@mui/material/Skeleton";
import { useTranslation } from "react-i18next";
import { Trans } from "react-i18next";

const GradientCardBody = styled(CardBody)`
  border-radius: 20px;
`;

const CardContainer = styled.div`
  margin: 0 auto;
`;

function Intervenants() {
  const navigate = useNavigate();
  const context = React.useContext(GlobalContext);
  const { t } = useTranslation();

  const handleEnSavoirPlusClick = (id_user) => {
    context.setSelectedIntervenantId(id_user);
  };

  // Filter items to include only active users
  /*  const onlineUsers = context.intervenantsData ? context.intervenantsData.filter(
    (item) => item.availability_user === 1
  ) : []; */

  const Users = context.intervenantsData || [];

  // Adjust the slidesToShow based on the number of available cards
  const slidesToShowCount = Users.length < 4 ? Users.length : 4;

  const sliderSettings = {
    arrows: true,
    style: { maxWidth: "80%", margin: "50px auto" },
    prevArrow: <div className="slick-prev"></div>,
    nextArrow: <div className="slick-next"></div>,
    infinite: Users.length >= 4, // Infinite scroll only when more than 4 users
    dots: false,
    speed: 500,
    slidesToShow: slidesToShowCount, // Dynamically set slidesToShow
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: false,
    responsive: [
      {
        breakpoint: 1570, // For large screens
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          style: {
            maxWidth: "80%",
            margin: "0 auto",
          },
        },
      },
      {
        breakpoint: 1200, // For large screens
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: true,
          dots: false,
          style: {
            maxWidth: "80%",
            margin: "0 auto",
          },
        },
      },
      {
        breakpoint: 768, // For small screens (phones)
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          arrows: false,
          dots: true,
          style: {
            maxWidth: "100%",
            margin: "0 auto",
          },
        },
      },
    ],
  };

  if (!context.intervenantsData) {
    return (
      <section className="bg-inter">
        <div className="second_row">
          <Typography
            variant="h2"
            sx={{
              color: "#3F4C52",
              textAlign: "center",
              fontFamily: "DM Serif Display",
              fontSize: {
                xs: "6vw", // Font size for extra small screens
                sm: "6vw", // Font size for small screens
                md: "6vw", // Font size for medium screens
                lg: "3.5vw", // Font size for large screens
                xl: "2.5vw", // Font size for extra large screens
              },
              fontStyle: "normal",
              fontWeight: 400,
            }}>
            {t("loadingTitle")}
          </Typography>

          <Typography
            variant="h4"
            sx={{
              color: "var(--taupe-fonc, #2E2E2E)",
              textAlign: "center",
              fontFamily: "Lato",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "35px",
            }}>
            {t("loadingSubtitle")}
          </Typography>
          <Slider {...sliderSettings}>
            {Array.from({ length: 3 }).map((_, index) => (
              <CardContainer key={index}>
                <Card style={{ width: "18rem" }} className="h-100">
                  <Skeleton variant="rectangular" height={270} />
                  <GradientCardBody>
                    <CardTitle tag="h5">
                      <Skeleton variant="text" width={100} />
                    </CardTitle>
                    <CardSubtitle tag="h6">
                      <Skeleton variant="text" width={80} />
                    </CardSubtitle>
                    <CardText
                      style={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="text" width={150} height={40} />
                    </CardText>
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Skeleton variant="text" width={100} height={30} />
                    </div>
                  </GradientCardBody>
                </Card>
              </CardContainer>
            ))}
          </Slider>
        </div>
        <div className="div-more">
          <center>
            <button
              className="btn-more"
              onClick={() => navigate("/intervenants")}
              disabled>
              {t("seeMoreIntervenants")}
            </button>
          </center>
        </div>
      </section>
    );
  }

  return (
    <div>
      <section className="bg-inter">
        <div className="second_row">
          <Typography
            variant="h2"
            sx={{
              color: "#3F4C52",
              textAlign: "center",
              fontFamily: "DM Serif Display",
              fontSize: {
                xs: "6vw", // Font size for extra small screens
                sm: "6vw", // Font size for small screens
                md: "6vw", // Font size for medium screens
                lg: "3.5vw", // Font size for large screens
                xl: "2.5vw", // Font size for extra large screens
              },
              fontStyle: "normal",
              fontWeight: 400,
            }}>
            {t("wellBeingTitle")}
          </Typography>
          <br></br>
          <Typography
            variant="h4"
            sx={{
              color: "var(--taupe-fonc, #2E2E2E)",
              textAlign: "center",
              fontFamily: "Lato",
              fontSize: "18px",
              fontStyle: "normal",
              fontWeight: 400,
              lineHeight: "30px",
            }}>
            <Trans i18nKey="wellBeingSubtitle">
              Notre système de matching intelligent vous connecte aux meilleurs
              experts,
              <br /> <br /> selon vos objectifs et vos critères, en un clin
              d’œil.
            </Trans>
          </Typography>
          <Slider {...sliderSettings}>
            {Users.map((item) => (
              <div key={item.id_user}>
                <Card style={{ width: "18rem" }} className="h-100">
                  <div
                    style={{
                      position: "absolute",
                      top: "10px",
                      left: "10px",
                      zIndex: 2,
                      padding: "5px 12px",
                      borderRadius: "30px",
                      fontSize: "12px",
                      fontWeight: "600",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                      backgroundColor:
                        item.availability_user === 1 ? "#53B1A6" : "#f3a109",
                      color: "#FFFFFF",
                      boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
                    }}>
                    {/* Point indicateur blanc/rouge */}
                    <span
                      style={{
                        width: "12px",
                        height: "12px",
                        borderRadius: "50%",
                        backgroundColor: "#FFFFFF",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}>
                      <span
                        className={
                          item.availability_user === 1 ? "clignote" : ""
                        } // Utilisez votre classe CSS existante
                        style={{
                          width: "7px",
                          height: "7px",
                          borderRadius: "50%",
                          backgroundColor:
                            item.availability_user === 1
                              ? "#06f762"
                          : "#e9a410",
                        }}></span>
                    </span>
                    {item.availability_user === 1 ? "En ligne" : "Sur RDV"}
                  </div>

                  <img
                    alt="Sample"
                    src={`${process.env.REACT_APP_APIURL}/storage/workshop/${item.photo_user}`}
                    className="user-photo"
                  />
                  <GradientCardBody>
                    <div
                      className="satisfaction-header"
                      style={{ marginBottom: "0px", textAlign: "end" }}>
                      <h6
                        style={{
                          fontFamily: "Lato",
                          fontSize: "16px",
                          color: "#2E2E2E",
                        }}>
                        {t("customerSatisfaction")}
                      </h6>
                    </div>
                    <div
                      className="custom-rating-container"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                      }}>
                      <p
                        className="text-medium"
                        style={{
                          fontFamily: "Lato",
                          fontSize: "16px",
                          fontWeight: 500,
                          lineHeight: "26px",
                          letterSpacing: "0em",
                          textAlign: "center",
                          marginRight: "10px",
                          color: "#2E2E2E",
                          marginBottom: "0",
                        }}>
                        4 / 5
                      </p>
                      <Rating
                        count={5}
                        value={4}
                        size={20}
                        // edit={true}
                        readOnly
                        activeColor="#ffffff"
                        inactiveColor="#d9d6d6"
                      />
                    </div>
                    <CardTitle
                      variant="h4"
                      style={{
                        color: "#3F4C52",
                        textAlign: "center",
                        fontFamily: "DM Serif Display",
                        fontSize: "clamp(1.5rem, 1.4vw, 1.4vw)",
                        fontStyle: "normal",
                        fontWeight: 400,
                      }}>
                      {item.nom_user} {item.prenom_user}
                    </CardTitle>
                    <CardSubtitle
                      className="mb-2"
                      tag="h6"
                      style={{
                        color: "#2E2E2E",
                        textAlign: "center",
                        fontSize: "18px",
                        fontFamily: "Lato",
                        fontWeight: "400",
                      }}>
                      {item.title_user}
                    </CardSubtitle>
                    <center>
                      <NavLink
                        to={`/intervenants/${item.nom_user}-${item.prenom_user}`}
                        className="btn btn_savoir btn-sm"
                        onClick={() => handleEnSavoirPlusClick(item.id_user)}>
                        {t("learnMore")}
                      </NavLink>
                    </center>
                  </GradientCardBody>
                </Card>
              </div>
            ))}
          </Slider>
        </div>
        <div className="div-more">
          <center>
            <button
              className="btn-more"
              onClick={() => navigate("/intervenants")}>
              {t("seeMoreIntervenants")}
            </button>
          </center>
        </div>
      </section>
    </div>
  );
}

export default Intervenants;
